import { Timestamp } from "firebase/firestore";
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Notification } from "../core/notification_handler";
import { vespidFunctionsAPI } from "../core/api";

/**
 * Gets and returns the partner data from the server based on the registration params
 * along with the loading state and search params.
 */
const usePartnerDataHandler = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isPartnerDataLoading, setIsPartnerDataLoading] = useState(false);
  const [partnerData, setPartnerData] = useState<any>({});

  const fetchPartnerData = async () => {
    setIsPartnerDataLoading(true);
    try {
      const registrationParam = searchParams.get("registration_param") || "";
      const response = await vespidFunctionsAPI.get(`/partners/registration/${registrationParam}`);
      const currDate = new Date();
      const registrationExpirationDate = new Timestamp(
        response.data.registration_expiration_date._seconds,
        response.data.registration_expiration_date._nanoseconds
      ).toDate();
      const isRegistrationEnabled = response?.data?.registration_enabled || false;

      if (!response) {
        Notification.error("Error fetching partner data.");
        setIsPartnerDataLoading(false);
        navigate("/auth_error");
        return;
      } else if (
        !isRegistrationEnabled || currDate > registrationExpirationDate
      ) {
        Notification.error("Registration is closed for this partner.");
        setIsPartnerDataLoading(false);
        navigate("/auth_error");
        return;
      }

      setPartnerData(response.data);
      setIsPartnerDataLoading(false);
    } catch (error: any) {
      setIsPartnerDataLoading(false);
      Notification.error("Error fetching partner data.");
      navigate("/auth_error");
    }
  };

  useEffect(() => {
    fetchPartnerData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, navigate]);

  return { partnerData, isPartnerDataLoading, searchParams };
};

export default usePartnerDataHandler;
